import { render, staticRenderFns } from "./AtualizacoesForm.vue?vue&type=template&id=8481f1ea&scoped=true&lang=pug&"
import script from "./AtualizacoesForm.vue?vue&type=script&lang=js&"
export * from "./AtualizacoesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8481f1ea",
  null
  
)

export default component.exports